import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

const state = {
  searchText: '',
  mitelConnectionStatus: "",
  mitelCallCode: null,
  mitelCallerName: "",
  mitelCallerNumber: ""
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/index.js